import { CUSTOMER_JOURNEY_LOGIN } from './../const';

function action(reservationId, surname, lang, successCallback, errorCallback) {
  return { type: CUSTOMER_JOURNEY_LOGIN, reservationId, surname, lang, successCallback, errorCallback };
}

module.exports = action;



// WEBPACK FOOTER //
// ./actions/customerJourney/customerJourneyLogin.js